<template>
  <DvStyleProvider :transformers="[px2remTransformer({ rootValue: 1 })]">
    <dv-config-provider :theme="antTheme">
      <dv-spin class="abs-full" spinning v-if="store.initIng && !route.name" :delay="100" />
      <RouterView />
    </dv-config-provider>
  </DvStyleProvider>
</template>

<script setup lang="ts">
import { useTheme, px2remTransformer } from '@mogic/dv-design'
import { useTitle } from '@da-vinci/hooks'
import { useUpdateRumConfig } from './utils/rum'

useUpdateRumConfig()
const { antTheme } = useTheme('dark')
const route = useRoute()
const routeTitle = computed(() => (route.meta.title ? `-${route.meta.title}` : ''))
useTitle(computed(() => __APP_TITLE_PRE__ + '爆款复刻机' + routeTitle.value))
const store = useStore()
</script>

<style>
::-webkit-scrollbar {
  display: none;
}
body {
  overflow-wrap: break-word;
}
</style>
